import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import TaskSearchItem from "./TaskSearchItem";

const JobTasks = ({
  tasks = [],
  onAddClick,
  onEditClick,
  onTaskDelete,
  onStatusUpdate,
  jobId,
}) => {
  return (
    <div className="">
      <div className="d-flex">
        <div className="flex-grow-1 ">
          <h6 className="m-0">Tasks</h6>
        </div>

        <Button
          variant="info"
          size="sm"
          onClick={onAddClick}
          className="px-1 py-0"
        >
          Add
        </Button>
      </div>
      <hr style={{ marginTop: "7px" }} className="mb-0 mx-0" />
      {tasks.length > 0 ? (
        <Row noGutters className="py-1 h-100">
          {tasks.map((task, index) => (
            <Col key={"task-" + Math.random()} xs={12} lg={6} className="p-1 h-auto">
              <TaskSearchItem
                task={task}
                fromDetails
                onEditClick={() => onEditClick(task, index)}
                onStatusUpdate={onStatusUpdate}
                onTaskDelete={onTaskDelete}
                taskIndex={index}
                tasks={tasks}
                jobId={jobId}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Row className="my-4 text-center">
          <Col>
            <p style={{ fontSize: 14 }} className="mb-1">
              No tasks found!
            </p>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default JobTasks;
